import api from "./api";

export const getPlans = async () => {
    const { data } = await api.get('/signature/home/plans');

    return data
}